import { $http } from "@/utils/http";
import {
    SET_PRODUCTS_LIST,
    SET_LOADING_PRODUCTS_LIST,
    SET_PRODUCTS_ITEM,
    SET_LOADING_PRODUCTS_ITEM,
    SET_LIST_LENGTH,
    CHANGE_SKIP,
    CHANGE_CATEGORY,
    CHANGE_SKIP_MOBILE,
    SET_MOBILE_PRODUCTS_LIST,
    SET_MOBILE_LIST_LENGTH,
    SET_MOBILE_LOADING_PRODUCTS_LIST,
    PRODUCT_LENGTH,
} from "../mutation-types";

import { GET_PRODUCTS_LIST, GET_PRODUCTS_ITEM, GET_MOBILE_PRODUCTS_LIST } from "../action-types";

const state = {
    list: null,
    listLoading: false,
    item: null,
    itemLoading: false,
    skip: 0,
    limit: 2,
    limitMobile: 16,
    listLength: 0,
    mobileList: null,
    mobileListLoading: false,
    mobileListLength: 0,
    productLength: 0,
};

const getters = {
    list: state => state.list,
    listLoading: state => state.listLoading,
    item: state => state.item,
    itemLoading: state => state.itemLoading,
    skip: state => state.skip,
    limit: state => state.limit,
    limitMobile: state => state.limitMobile,
    listLength: state => state.listLength,
    mobileList: state => state.mobileList,
    mobileListLoading: state => state.mobileListLoading,
    mobileListLength: state => state.mobileListLength,
    productLength: state => state.productLength,
};

const actions = {
    [GET_PRODUCTS_LIST]: async ({ commit }) => {
        commit(SET_LOADING_PRODUCTS_LIST, true);
        try {
            commit(CHANGE_SKIP);
            const response = await $http.get(`v1/products-for-sale?per-page=${state.skip}`);
            commit(SET_PRODUCTS_LIST, response.data.data);
            commit(PRODUCT_LENGTH, response.data.data.length);
            commit(SET_LIST_LENGTH, response.data.meta.total);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_LOADING_PRODUCTS_LIST, false);
        }
    },
    [GET_MOBILE_PRODUCTS_LIST]: async ({ commit }) => {
        commit(SET_MOBILE_LOADING_PRODUCTS_LIST, true);
        try {
            const response = await $http.get(`v1/products-for-sale?per-page=${state.limitMobile}`);
            commit(SET_MOBILE_PRODUCTS_LIST, response.data.data);
            commit(SET_MOBILE_LIST_LENGTH, response.data.meta.total);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_MOBILE_LOADING_PRODUCTS_LIST, false);
        }
    },
    [GET_PRODUCTS_ITEM]: async ({ commit }, payload) => {
        commit(SET_LOADING_PRODUCTS_ITEM, true);
        try {
            const response = await $http.get(`v1/articles/${payload.id}`);
            commit(SET_PRODUCTS_ITEM, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_LOADING_PRODUCTS_ITEM, false);
        }
    },
};

const mutations = {
    [PRODUCT_LENGTH](state, data) {
        state.productLength = data;
    },
    [SET_PRODUCTS_LIST](state, list) {
        state.list = list;
    },
    [SET_LOADING_PRODUCTS_LIST](state, status) {
        state.listLoading = status;
    },
    [SET_PRODUCTS_ITEM](state, data) {
        state.item = data;
    },
    [SET_LOADING_PRODUCTS_ITEM](state, status) {
        state.itemLoading = status;
    },
    [SET_LIST_LENGTH](state, data) {
        state.listLength = data;
    },
    [CHANGE_SKIP](state) {
        state.skip += state.limit;
    },
    [CHANGE_SKIP_MOBILE](data) {
        state.skip = data;
    },
    [CHANGE_CATEGORY](state, category) {
        state.activeCategory = category;
        state.skip = 6;
        state.listLength = 0;
        state.list = null;
    },
    [SET_MOBILE_PRODUCTS_LIST](state, list) {
        state.mobileList = list;
    },
    [SET_MOBILE_LOADING_PRODUCTS_LIST](state, status) {
        state.mobileListLoading = status;
    },
    [SET_MOBILE_LIST_LENGTH](state, data) {
        state.mobileListLength = data;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
